import React, { useState, useEffect } from "react";
import { Calendar, Phone, CheckSquare, User } from "lucide-react"; // icons
import { Row } from "react-bootstrap";
import { formatDateTime } from "../../../../Components/DateFn";

const OpenActivitiesView = ({ activities }) => {
    const [openActivities, setOpenActivities] = useState([]);
    const [openTasks, setOpenTasks] = useState([]);
    const [openMeetings, setOpenMeetings] = useState([]);
    const [openCalls, setOpenCalls] = useState([]);

    const pushIfNotExist = (arr, item) => {
        if (!arr.some(i => i._id === item._id)) {
            arr.push(item);
        }
    };

    useEffect(() => {
        if (!activities || activities.length === 0) {
            setOpenActivities([]);
            return;
        }
        const now = new Date();
        const open = [];

        activities.forEach((item) => {
            const { data } = item;
            const type = data?.type;

            if (type === "Tasks") {
                const dueDate = new Date(data.Due_Date);
                const status = data.Status?.trim().toLowerCase();
                if (dueDate >= now && status !== "completed") pushIfNotExist(open, item);//open.push(item);
                if (status !== "completed") pushIfNotExist(open, item);//open.push(item);
            } else if (type === "Meetings") {
                const toDate = new Date(data.To);
                if (toDate >= now && data.Status !== "Completed" && data.Status !== "Cancelled") pushIfNotExist(open, item);//open.push(item);
                if (data.Status !== "Completed" && data.Status !== "Cancelled") pushIfNotExist(open, item);//open.push(item);
            } else if (type === "Calls") {
                const callStart = new Date(data.Call_Start_Time);
                if (callStart >= now && data.Outgoing_Call_Status !== "Completed" && data.Outgoing_Call_Status !== "Cancelled") pushIfNotExist(open, item);//open.push(item);
                if (data.Outgoing_Call_Status !== "Completed" && data.Outgoing_Call_Status !== "Cancelled") pushIfNotExist(open, item);//open.push(item);
            }
        });
        setOpenActivities(open);
    }, [activities]);


    useEffect(() => {
        if (openActivities?.length === 0) {
            setOpenTasks([]);
            setOpenMeetings([]);
            setOpenCalls([]);
            return;
        } else {
            setOpenTasks(openActivities.filter((a) => a.data.type === "Tasks"));
            setOpenMeetings(openActivities.filter((a) => a.data.type === "Meetings"));
            setOpenCalls(openActivities.filter((a) => a.data.type === "Calls"));
        }
    }, [openActivities]);

    return (
        <>
            {openTasks?.length === 0 && openMeetings?.length === 0 && openCalls?.length === 0 ?
                <div>No records found</div>
                : <div className="bg-white border rounded-lg shadow-sm mt-1 rounded">
                    {/* Columns */}
                    <div className="grid grid-cols-3 divide-x border-t">
                        <Row>
                            <div className="col-4">
                                <div className="p-3">
                                    <div className="d-flex align-items-center">
                                        <CheckSquare size={13} />
                                        <div className="ms-2 fw-semibold">
                                            Open Tasks{" "}
                                            <span style={{
                                                border: '2px solid lightgrey',
                                                borderRadius: '25px',
                                                background: 'lightgrey',
                                                padding: '0 3px'
                                            }}>
                                                {openTasks.length}
                                            </span>
                                        </div>
                                    </div>
                                    {openTasks.length > 0 ? (
                                        openTasks.map((task) => (
                                            <div key={task._id} className="border-b border-gray-200 pb-2 mb-2">
                                                <div style={{ color: '#5464F2' }}>
                                                    {task.data.Subject}
                                                </div>
                                                <div className="fs-13">{new Date(task.data.Due_Date).toLocaleDateString("en-GB")}</div>
                                                <div className="fs-13 mb-2">
                                                    <User size={13} />{task.data.Task_Owner?.name}
                                                </div>
                                                <div className="fs-13">
                                                    Status : {task.data.Status}
                                                </div>
                                                <div className="fs-13">
                                                    Priority : {task.data.Priority}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="fs-13">No open tasks</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="p-3">
                                    <div className="d-flex align-items-center">
                                        <Calendar size={13} />
                                        <div className="ms-2 fw-semibold">
                                            Open Meetings{" "}
                                            <span style={{
                                                border: '2px solid lightgrey',
                                                borderRadius: '25px',
                                                background: 'lightgrey',
                                                padding: '0 3px'
                                            }}>
                                                {openMeetings.length}
                                            </span>
                                        </div>
                                    </div>
                                    {openMeetings.length > 0 ? (
                                        openMeetings.map((meeting) => (
                                            <div
                                                key={meeting._id}
                                                className="border-b border-gray-200 pb-2 mb-2"
                                            >
                                                <div className="fs-13" style={{ color: '#5464F2' }}>
                                                    {meeting.data.Title}
                                                </div>
                                                <div className="fs-13">
                                                    {formatDateTime(meeting.data.From)} - {formatDateTime(meeting.data.To)}
                                                </div>
                                                <div className="fs-13">
                                                    <User size={13} /> {meeting.data.Host?.name}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="fs-13">No open meetings</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="p-3">
                                    <div className="d-flex align-items-center">
                                        <Phone size={13} />
                                        <div className="ms-2 fw-semibold">
                                            Open Calls{" "}
                                            <span style={{
                                                border: '2px solid lightgrey',
                                                borderRadius: '25px',
                                                background: 'lightgrey',
                                                padding: '0 3px'
                                            }}>
                                                {openCalls.length}
                                            </span>
                                        </div>
                                    </div>
                                    {openCalls.length > 0 ? (
                                        openCalls.map((call) => (
                                            <div key={call._id} className="border-b border-gray-200 pb-2 mb-2">
                                                <div className="fs-13" style={{ color: '#5464F2' }}>
                                                    {call.data.Subject || call.data.Call_Type + " Call"}
                                                </div>
                                                <div className="fs-13">
                                                    {formatDateTime(call.data.Call_Start_Time)}
                                                </div>
                                                <div className="fs-13">
                                                    <User size={13} /> {call.data.Call_Owner?.name}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="fs-13">No open calls</div>
                                    )}
                                </div>
                            </div>
                        </Row>
                    </div >
                </div >
            }
        </>
    );
};

export default OpenActivitiesView;
